import gql from 'graphql-tag';

const CLUBS_BASIC = gql`
query clubs($offset: Int, $limit: Int, $sort: [ClubSortInput!], $filter: [ClubFilterInput]) {
  clubs(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
    totalCount
    items {
      id
      profile {
        name
      }
      licenses {
        current {
          isLicensed
        }
        next {
          isLicensed
        }
      }
    }
  }
}
`;

export default CLUBS_BASIC;
